module.exports = __webpack_public_path__ + "img/dashboard-logo.c5f7df6d.png";